import ValidatedField from "@/validation/ValidatedField";
import ValidatedForm from "@/validation/ValidatedForm";
import Rpc from "@/Rpc"


export default class ChangePasswordForm extends ValidatedForm {
    constructor() {
        super();
        this.password = new ValidatedField(this,"");
        this.password2 = new ValidatedField(this,"",
            (value) => value === this.password.value ? true : 'Passwords need to match');

        this.password.validationFunction = async (value) => {
            let res = await Rpc.Session.validatePassword(value);
            this.password2.validate().then();
            return res;
        };
        this.setLabels();
    }

    async saveUser(){
        try {
            await Rpc.Users.editMyPassword(this.password.value).lock();
        }
        catch(e) {
            this.parseException(e);
        }
    }

}